import React, { useState, useReducer } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Autocomplete from 'react-autocomplete';
import TagsInput from 'react-tagsinput';
import Dropzone from 'react-dropzone';
import PulpoField from '../../../../pulpo_visualizer/fields';
import styles from '../../../workorders/Create/components/fixedFields.module.scss';
import fieldstyles from '../../../../pulpo_visualizer/fields/fields.module.scss';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import Clickable from '../../../../components/clickable/Clickable';

const DefaultFields = ({
  info,
  types,
  subtypes,
  userlist,
  searchForUser,
  handleAnswerChanged,
  showFieldErrors,
  handleFieldErrorChanged,
  intl,
  user,
  tags
}) => {
  // State Hooks
  const [currentValue, setCurrentValue] = useState('');
  // handles type of autocomplete
  const handleAutocompleteChange = (e) => {
    setCurrentValue(e.target.value);
    searchForUser(e.target.value);
  };
  useReducer(() => {
    setCurrentValue(info.currentValue);
  }, []);
  const handleAutocompleteSelect = (val, item) => {
    setCurrentValue(val);
    handleAnswerChanged(item, 'logged_by');
    handleFieldErrorChanged('logged_by', false);
  };

  const handleDrop = (dropped) => {
    const res = info.attachments || [];
    handleAnswerChanged([...res, ...dropped], 'attachments');
  };
  const handleRemoveImage = (r) => {
    const res = info.attachments.filter(e => e !== r);
    handleAnswerChanged(res, 'attachments', r.id);
    handleAnswerChanged(r.id, 'removedAttachments');
  };
  if (user && user.id && !currentValue) {
    handleAnswerChanged(user, 'logged_by');
    setCurrentValue(user.fullname);
  }

  const result = [].concat.apply([], tags);
  const recent_tags =result.slice(0, 5);

  return (
    <>
      <div className={fieldstyles.field}>
        <FormattedMessageWithClass
          className={fieldstyles.title} id="operations.create.by"
          defaultMessage="Logged by"
        />
        <Autocomplete getItemValue={item => item.fullname} items={userlist}
          wrapperStyle={{ position: 'relative' }}
          value={currentValue}
          onChange={handleAutocompleteChange}
          onSelect={handleAutocompleteSelect}
          renderMenu={children => (
            <div className={styles.autocompleteMenu}>
              {children}
            </div>
          )}
          renderItem={(item, isHighlighted) => (
            <div key={item.id} className={`${styles.menuItem} ${isHighlighted && styles.highlighted}`}>
              {item && item.fullname}
            </div>
          )}
        />
        {!currentValue && showFieldErrors && (
          <small>
            <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="There is an error in this field" />
          </small>
        )}
      </div>
      <PulpoField key="report_date" id="report_date" type="datetime"
        translationID="workorder.create.date" title="Report date"
        isRequired handleValueChange={a => handleAnswerChanged(a, 'report_date')}
        answer={info.report_date}
        showFieldErrors={showFieldErrors}
        handleFieldErrorChanged={handleFieldErrorChanged}
      />

      <PulpoField key="shift" id="shift" type="string"
        translationID="operations.builder.shifts" title="Shift"
        isRequired disabled handleValueChange={a => handleAnswerChanged(a, 'report_date')}
        answer={info.shift_name}
        showFieldErrors={showFieldErrors}
        handleFieldErrorChanged={handleFieldErrorChanged}
      />
      <PulpoField key="type" id="type" type="select" title="Category" isRequired
        translationID="operations.create.type" className={styles.fullInput}
        handleValueChange={a => handleAnswerChanged(a, 'type')}
        answer={info.type}
        showFieldErrors={showFieldErrors}
        handleFieldErrorChanged={handleFieldErrorChanged}
        values={types.map(e => ({ key: `${e.name}`, value: (e.i18n_id ? intl.formatMessage({ id: `operations.log.${e.i18n_id}` }) : e.name) }))}
      />
      {info.type && ((subtypes.filter(s => s.activity_type.name === info.type)).length > 0) &&(
        <PulpoField key="subtype" id="subtype" type="select" title="Sub-Category" isRequired
          translationID="operations.create.subtype" className={styles.fullInput}
          handleValueChange={a => handleAnswerChanged(a, 'subtype')}
          answer={info.subtype}
          showFieldErrors={showFieldErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
          values={subtypes.filter(
            s => s.activity_type.name === info.type
          ).map(e => ({ key: `${e.name}`, value: (e.i18n_id ? intl.formatMessage({ id: `operations.log.${e.i18n_id}` }) : e.name) }))}
        />
      )}
  
      <PulpoField key="desc" id="description" type="string"
        translationID="operations.create.description" className={styles.fullInput}
        widget={{ type: 'textarea' }} title="Description" isRequired
        handleValueChange={a => handleAnswerChanged(a, 'description')}
        answer={info.description}
        showFieldErrors={showFieldErrors} handleFieldErrorChanged={handleFieldErrorChanged}
      />

      <div>
        <div>
          <FormattedMessageWithClass className={styles.label}
            id="operations.create.tags" defaultMessage="Tags"
          />
        </div>
        <label htmlFor="Name">
        <TagsInput value={info.tags} onlyUnique inputProps={{ placeholder: 'Create a new tag' }}
            onChange={tags => handleAnswerChanged(tags, 'tags')} addKeys={[9, 13, 188]}
          />
        </label>
      </div>
      <div className={fieldstyles.field}>
        <span>
          <FormattedMessageWithClass id="operations.create.RecentTags" className={fieldstyles.title} defaultMessage="Recent tags" />
        </span>
        <div>
          {recent_tags.map(k => (
            <div>
              <label htmlFor="Name">
                <span style={{ backgroundColor: 'white', color: '#3A61A8', border: '1px solid #3A61A8', borderRadius: '20px', padding: '2px 15px' }}>
                  {k}
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.fullInput}>
        <FormattedMessageWithClass className={styles.label}
          id="workorder.create.photos" defaultMessage="Photos"
        />
        <Dropzone onDrop={handleDrop} disableClick
          className={styles.dropzone} accept="image/*"
        >
          {({ open }) => (
                <>
                  <p className={`${styles.browsetext} ${styles.browsetext}`}>
                    <FormattedMessage id="airport.logo.text1"
                      defaultMessage="Drag an image here or"
                    />
                    <button type="button" onClick={() => open()}>
                      <FormattedMessage id="airport.logo.button"
                        defaultMessage="browse"
                      />
                    </button>
                    <FormattedMessage id="airport.logo.text2"
                      defaultMessage="for an image to upload."
                    />
                  </p>
                </>
          )}
        </Dropzone>
        {info.attachments && info.attachments.length > 0 && (
        <div className={styles.photos} key={info.id}>
          {info.attachments.map(e => (
            <div key={`${info.id}-${e.name || e.id}`} className={`${styles.wrapper} ${styles.wrapper}`}>
              <Clickable onClick={() => handleRemoveImage(e)}>&times;</Clickable>
              <img src={e.preview || e.image} alt={e.name || e.id} />
            </div>
          ))}
        </div>
        )}
      </div>
    </>
  );
};

DefaultFields.propTypes = {
  info: PropTypes.shape({}).isRequired,
  userlist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchForUser: PropTypes.func.isRequired,
  showFieldErrors: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  handleAnswerChanged: PropTypes.func.isRequired,
  types: PropTypes.arrayOf(PropTypes.shape({})),
  subtypes: PropTypes.arrayOf(PropTypes.shape({})),
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  user: PropTypes.shape({})
};

DefaultFields.defaultProps = {
  types: [],
  subtypes: [],
  tags: []
};
export default injectIntl(DefaultFields); 
